export const redirectTo = url => {
  window.location.href = url;
};